import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'

/**
 * Handler genérico para todos los links de email de Supabase Auth.
 * El email manda al usuario acá con ?token_hash=...&type=XXX
 * Verificamos el token (que crea la sesión) y redirigimos según el tipo.
 *
 * Tipos soportados:
 *  - signup        → bienvenida, va a /tienda
 *  - magiclink     → login con link, va a /tienda
 *  - recovery      → reset password, va a /set-password
 *  - email_change  → cambio de email, va a /mi-cuenta
 *  - invite        → invitación admin, va a /set-password (debe elegir contraseña)
 */
export default function AuthCallback() {
  const [error, setError] = useState(null)
  const [params] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const tokenHash = params.get('token_hash')
    const type = params.get('type')
    const next = params.get('next') // override opcional

    if (!tokenHash || !type) {
      setError('El link es inválido o está incompleto. Pedí uno nuevo.')
      return
    }

    ;(async () => {
      const { error: verifyError } = await supabase.auth.verifyOtp({
        token_hash: tokenHash,
        type,
      })

      if (verifyError) {
        // mensajes humanos
        const msg = /expired|invalid/i.test(verifyError.message)
          ? 'El link expiró o ya fue usado. Pedí uno nuevo y revisá tu bandeja.'
          : `No pudimos verificar el link: ${verifyError.message}`
        setError(msg)
        return
      }

      // Redirigir según el tipo
      let target = next || '/'
      if (!next) {
        switch (type) {
          case 'recovery':
          case 'invite':
            target = '/set-password'
            break
          case 'email_change':
            target = '/mi-cuenta'
            break
          case 'signup':
          case 'magiclink':
          default:
            target = '/catalogo'
        }
      }
      navigate(target, { replace: true })
    })()
  }, [params, navigate])

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="brand">Lim<em>pack</em></div>
        <div className="tag">Limpieza, resuelta cada mes.</div>

        {error ? (
          <div style={{ marginTop: 24, padding: 16, background: '#FEF2F2', border: '1.5px solid #FCA5A5', borderRadius: 10 }}>
            <p style={{ margin: 0, color: '#991B1B', fontWeight: 600 }}>{error}</p>
            <p style={{ marginTop: 12, marginBottom: 0 }}>
              <a href="/reset-password" style={{ color: '#00A8B5', fontWeight: 600 }}>Pedir un nuevo link →</a>
            </p>
          </div>
        ) : (
          <div style={{ marginTop: 32, textAlign: 'center', color: 'var(--muted)' }}>
            Verificando tu link…
          </div>
        )}
      </div>
    </div>
  )
}
